import { render } from "./SelectApi.vue?vue&type=template&id=039a27ce&scoped=true"
import script from "./SelectApi.vue?vue&type=script&lang=js"
export * from "./SelectApi.vue?vue&type=script&lang=js"

import "./SelectApi.vue?vue&type=style&index=0&id=039a27ce&lang=scss&scoped=true"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039a27ce"]])

export default __exports__